import React from "react";
import { Link } from "react-router-dom";
import "../styles/BlogFile.css";

function Blog3() {
  return (
    <div className="blog-post-container">
      <h2 className="blog-post-title">Preventing CTE: Science, Innovation & Awareness</h2>
      <p className="blog-post-date">May 2025</p>

      <h3 className="blog-post-title">What is CTE and Why is it a Growing Concern?</h3>
      <p className="blog-post-content">
        Chronic Traumatic Encephalopathy (CTE) is a progressive brain disease associated with repeated head injuries. 
        It is primarily found in athletes, military personnel, and individuals in high-impact professions. 
        The condition develops gradually, often with symptoms appearing years after the initial trauma.
      </p>

      <p className="blog-post-content">
        Symptoms of CTE include:  
        - Memory loss and cognitive impairment  
        - Emotional instability, depression, and anxiety  
        - Difficulty with impulse control and decision-making  
        - Motor function decline in later stages  
      </p>

      <h3 className="blog-post-title">The Challenges of Diagnosing CTE</h3>
      <p className="blog-post-content">
        One of the biggest challenges in CTE research is that the condition can only be definitively diagnosed after death through brain tissue analysis. 
        Researchers are working to develop biomarkers and imaging techniques that can detect early signs of CTE in living individuals. 
        This would allow for earlier interventions and potentially slow the disease's progression.
      </p>

      <h3 className="blog-post-title">Innovative Solutions to Reduce CTE Risk</h3>
      <p className="blog-post-content">
        Advances in technology are helping reduce the risk of repeated head injuries in sports and military operations.  
        Key developments include:  
        - Helmets designed to absorb and redistribute impact forces  
        - AI-powered monitoring systems that detect high-risk impacts in real time  
        - Stricter return-to-play and medical clearance protocols  
      </p>

      <h3 className="blog-post-title">How AI is Changing CTE Prevention</h3>
      <p className="blog-post-content">
        AI-driven monitoring systems are playing an increasingly important role in CTE prevention. 
        By analyzing player impact data, symptom history, and cognitive changes, AI can provide risk assessments for individual athletes.  
        This allows medical professionals to make more informed decisions about injury management and long-term brain health.
      </p>

      <p className="blog-post-content">
        The future of CTE prevention relies on a combination of improved equipment, better injury tracking, and responsible decision-making.  
        AI-assisted monitoring will help ensure that players, military personnel, and workers at risk for repeated head trauma receive the care they need before irreversible damage occurs.
      </p>

      <div className="back-to-blog">
        <Link to="/blog">← Back to Blog</Link>
      </div>
    </div>
  );
}

export default Blog3;